import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SessionAssociationDialog } from "@/components/SessionAssociationDialog";
import { UnsubscribeDialog } from "@/components/UnsubscribeDialog";
import { useSessionTracking } from "@/hooks/useSessionTracking";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const AppContent = () => {
  const { showAssociationPrompt, associateSession, dismissPrompt } = useSessionTracking();

  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/post/:id" element={<Index />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <SessionAssociationDialog
        open={showAssociationPrompt}
        onAssociate={associateSession}
        onDismiss={dismissPrompt}
      />
      <UnsubscribeDialog />
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
